var Pixel = Pixel || {};

Pixel.events = (function (Backbone, _) {
	return _.clone(Backbone.Events);
})(Backbone, _);

Pixel.PixelBase = (function (Backbone, pixelEmitter) {
	var PixelBase = function (opts) {
		_.bindAll(this, '_callCallback');

		opts = opts || {};
		this._opts = opts;

		opts.pixelEmitter && (this._pixelEmitter = opts.pixelEmitter);
		opts.api && (this._api = opts.api);
		opts.id && (this._id = opts.id);

		this._subscribe();

		_.isFunction(this.initialize) && this.initialize.apply(this, arguments);

		!opts.muteHistoryEvents && this._applyEventsHistory();
	};

	PixelBase.eventsHistory = [];

	_.extend(PixelBase.prototype, Backbone.Events, {
		_pixelEmitter: pixelEmitter,

		_subscribe: function() {
			this._pixelEmitter.on('all', this._callCallback);
		},

		_callCallback: function (eventName) {
			try {
				var args = Array.prototype.slice.call(arguments, 1),
					cb = this[eventName];
				_.isFunction(cb) && cb.apply(this, args);
			} catch (e) {
				window.NREUM && _.isFunction(window.NREUM.noticeError) && window.NREUM.noticeError(e);
			}
		},

		_applyEventsHistory: function() {
			for (var i = 0; i < PixelBase.eventsHistory.length; i++) {
				this._callCallback.apply(this, PixelBase.eventsHistory[i]);
			}
		},

		_priceStringToFloat: function (price) {
			return _.isString(price) && parseFloat(price.replace(/[^.\d]/gi, '')) || price;
		}
	});

	pixelEmitter.on('all', function () {
		PixelBase.eventsHistory.push(arguments);
	});

	PixelBase.extend = Backbone.Model.extend;

	return PixelBase;
})(Backbone, Pixel.events);

Pixel.registrationTrack = (function (app) {
	return {
		setRegistred: function () {
			app.cookie.set('r', '1');
		},

		isSomewhenRegistred: function() {
			return app.cookie.get('r') !== null;
		},

		isJustRegistred: function () {
			if (parseInt(app.cookie.get('r'))) {
				app.cookie.set('r', '0');
				return true;
			}
			return false;
		}
	}
})(app);

!function ($, Pixel) {
	$(window).on('load', function () {
		Pixel.events.trigger('pageView');
		Pixel.registrationTrack.isJustRegistred() && Pixel.events.trigger('registrationSuccess');
	});
}(jQuery, Pixel);